/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import {
  Typography,
  List,
} from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { Scrollbars } from "react-custom-scrollbars";

import BackButton from '../../components/BackButton';
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";
import { get } from "../../modules/http/shared";
import { downloadFile } from "../../modules/http/shared";
import { isAuth, getToken } from "../../modules/auth/shared/utils/auth";
import SectionsList from "./components/SectionsList"
import DocsList from "./components/DocsList"
import HelpPageContent from "./components/HelpPageContent"
import { helpPageDocs, helpPageSections } from "./constants/HelpPageConfig";
import { docItem, sectionItem } from "./constants/types";
import messages from "./constants/messages";
import {styles} from "./constants/styles"

type Props = WithStyles<typeof styles>;

const HelpPage: React.FC<Props> = (props: Props) => {
  const storedSelectedItem = sessionStorage.getItem('HelpPageSelectedId')
  const [selectedItem, setSelectedItem] = React.useState<string>(storedSelectedItem || helpPageSections[0].id);

  const addAuthInHeadersOption = () => {
    let options = {};
    if (isAuth()) {
      const token = getToken();
      options = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': -1,
        },
      };
    }
    return options;
  };

  const download = async (item: docItem) => {
    try {
      const options = addAuthInHeadersOption();
      const response = await get(item.download!, undefined, options);
      if (response.ok) {
        const fileName = `${item.id}${item.extension}`;
        const blob = await response.blob();
        const navigatorAs = window.navigator as any;
        if (navigatorAs?.msSaveOrOpenBlob) { // for IE
          navigatorAs?.msSaveOrOpenBlob(blob, fileName);
        } else { // for non-IE
          downloadFile(blob, fileName);
        }
      }
    } catch (err) {}
  };

  const saveSelectedItem = (selectedId: string) => {
    sessionStorage.setItem('HelpPageSelectedId', selectedId)
    setSelectedItem(selectedId)
  }

  const { classes } = props;
  
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <div className={classes.sideMenu}>
          <div className={classes.headerContainer} style={{marginBottom: 16}}>
            <BackButton/>
            <Typography className={classes.header}>
              <FormattedMessage {...messages.HelpTopics} />
            </Typography>
          </div>
          <Scrollbars key={'HelpPage.Scrollbar.SideMenu'} autoHide>
            <SectionsList
              selectedItem={selectedItem} 
              setSelectedItem={(id: string) => saveSelectedItem(id)}
            />
            <Typography className={classes.subtitle}>
              <FormattedMessage {...messages.Docs} />
            </Typography>
            <List component="div" dense>
              {helpPageDocs.map((item) => <DocsList item={item} download={download}/>)}
            </List>
          </Scrollbars>
        </div>
        <div className={classes.content}>
          <HelpPageContent selectedItemId={selectedItem} setSelectedItemId={saveSelectedItem}/>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(HelpPage);
